<section class="section md-cta md-cta-f" [id]="dataLanding.commonsOptions.idMenu" >
    <div class="container text-center position-relative">
        <p *ngIf="dataLanding.schema.subtitle.properties.visible" class="subtitle">{{dataLanding.schema.subtitle.properties.data}}</p>
        <h2 *ngIf="dataLanding.schema.title.properties.visible" [class]="dataLanding.schema.title.properties.fontSize">{{dataLanding.schema.title.properties.data}}</h2>
        <div class="lead" *ngIf="dataLanding.schema.claim.properties.visible" [innerHTML]="dataLanding.schema.claim.properties.data"></div>
    </div>
  </section>